
import { eventsActions } from './events.era';
import { createActionGroup, createFeature, createFeatureSelector, createReducer, on } from '@ngrx/store'
import { userActions } from './user.era';

export interface PaymentState {
  header_title:string
  header_class:string
  show_promo_input:boolean
  btn_prev:boolean
  btn_dont:boolean
  btn_cancel:boolean
  btn_close:boolean
  btn_update:boolean
  btn_next:boolean
  btn_cta:boolean
  btn_remove:boolean
  btn_got_it:boolean
}

const initialStateCreator = (): PaymentState => ({
  header_title:'Joi Subscription',
  header_class:'',
  show_promo_input:false,
  btn_prev: false,
  btn_dont:false,
  btn_cancel:true,
  btn_close:false,
  btn_update:false,
  btn_next:true,
  btn_cta:false,
  btn_remove:false,
  btn_got_it:false
})

export const paymentActions = createActionGroup({
  source: 'Payment',
  events: {
    'Update State': (payload:Partial<PaymentState>) => ({ payload }),
    'Update State Item': (key:string, value:string | boolean) => ({ key, value }),
    'Set Buttons': (payload?:string[]) => ({ payload })
  }
})

export const paymentReducer = createReducer(
  initialStateCreator(),
  on(paymentActions.updateState, (state, { payload }) => ({ ...state, ...payload })),
  on(paymentActions.updateStateItem, (state, { key, value }) => ({ ...state, [key]:value })),
  on(paymentActions.setButtons, (state, { payload }) => {
    const blank_state = initialStateCreator();
    const update_obj = {}
    Object.keys(blank_state).filter(k=>/^btn_/.test(k)).forEach(btn_key=>{
      const key = btn_key.replace('btn_','')
      update_obj[btn_key] = payload ? payload.includes(key) : blank_state[btn_key]
    })
    return {
      ...state,
      ...update_obj
    }
  }),
  on(userActions.logout, (state) => initialStateCreator()),
  on(eventsActions.unloadEvent, (state) => initialStateCreator())
)

export const paymentFeature = createFeature({
  name: 'payment',
  reducer: paymentReducer
})

export const paymentStateSelector = createFeatureSelector<PaymentState>(paymentFeature.name)

